/* eslint-disable react/prop-types, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, inkA } from '../tokens';

// Destructive "are you sure?" confirmation dialog. Spec source:
// users-accounts.jsx confirm modal (red icon disc, title, body, Cancel +
// danger confirm). Esc / overlay click cancels.
const DANGER = '#E5483B';
const DANGER_ICON = '#D63A24';

const ConfirmModal = ({
  open,
  icon = 'trash-2',
  title,
  message,
  confirmLabel = 'Delete',
  confirmIcon = 'trash-2',
  loading = false,
  onConfirm,
  onCancel,
}) => {
  const theme = useTheme();
  const t = tokens(theme);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' && !loading) onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, loading, onCancel]);

  if (!open) return null;

  return (
    <div
      onClick={loading ? undefined : onCancel}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 150,
        background: 'rgba(0,0,0,0.72)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 32,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 420,
          background: t.card,
          border: '1px solid ' + t.border,
          borderRadius: 16,
          boxShadow: '0 30px 90px rgba(0,0,0,0.6)',
          padding: '26px 26px 22px',
        }}
      >
        <div
          style={{
            width: 52,
            height: 52,
            borderRadius: '50%',
            background: 'rgba(240,86,62,0.13)',
            border: '1px solid rgba(240,86,62,0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <Icon name={icon} size={22} color={DANGER_ICON} strokeWidth={2.25} />
        </div>
        <div style={{ fontSize: 18, fontWeight: 800, color: t.text }}>
          {title}
        </div>
        {message ? (
          <div
            style={{
              fontSize: '13.5px',
              color: t.sub,
              marginTop: 8,
              lineHeight: 1.5,
            }}
          >
            {message}
          </div>
        ) : null}
        <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            style={{
              flex: 1,
              height: 44,
              borderRadius: 9,
              cursor: loading ? 'default' : 'pointer',
              background: 'transparent',
              border: '1px solid ' + inkA(theme, 0.16),
              color: t.text,
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            style={{
              flex: 1,
              height: 44,
              borderRadius: 9,
              cursor: loading ? 'default' : 'pointer',
              background: DANGER,
              border: 'none',
              color: '#fff',
              fontSize: 14,
              fontWeight: 700,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              opacity: loading ? 0.7 : 1,
            }}
          >
            <Icon name={confirmIcon} size={16} color="#fff" />{' '}
            {loading ? 'Deleting…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
